import React, { useEffect, useState } from "react";
import Logo_b from "../assets/images/general/Logo_b.png";
import {
  Linkedin,
  Facebook,
  ArrowUpShort,
  Whatsapp,
  Github,
  Instagram,
  TwitterX,
} from "react-bootstrap-icons";
// import { Link } from "react-router-dom";
import { kontentVariables } from "../utils";
import useKontentServiceApi from "../services/useKontentServiceApi";
import { ReactComponent as InstagramColoredIcon } from "../assets/images/general/Instagram.svg";
// import useCategories from "../services/useCategories";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import styled from "styled-components";
import { COOKIE_STORAGE_KEY, COOKIE_CONSENT, COOKIE_EVENTS } from "../constants/consent";

const Footer = () => {
  const { data } = useKontentServiceApi(kontentVariables.footerPage);
  const [isActive, setIsActive] = useState(false);
  const [cookieConsent, setCookieConsent] = useState<string | null>(null);

  // const { categories } = useCategories("menu_category");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };
    window.addEventListener("load", handleScroll);
    document.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("load", handleScroll);
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const loadConsent = () => {
      setCookieConsent(localStorage.getItem(COOKIE_STORAGE_KEY));
    };

    loadConsent();

    window.addEventListener("storage", loadConsent);
    window.addEventListener(COOKIE_EVENTS.CONSENT_CHANGED, loadConsent);

    return () => {
      window.removeEventListener("storage", loadConsent);
      window.removeEventListener(COOKIE_EVENTS.CONSENT_CHANGED, loadConsent);
    };
  }, []);

  const scrollToTop = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const openCookieSettings = () => {
    window.dispatchEvent(new Event(COOKIE_EVENTS.OPEN_SETTINGS));
  };

  return (
    <>
      <footer id="footer" className="footer">
        <div className="container">
          <div className="row footer_first">
            <div className="col-lg-8 col-md-10 d-flex">
              <div className="footer-info-sec">
                <h2>
                  {data?.elements?.reach_out?.value.replace(
                    /(<([^>]+)>)/gi,
                    ""
                  )}
                </h2>
                <p>
                  {data?.elements?.step_into?.value.replace(
                    /(<([^>]+)>)/gi,
                    ""
                  )}
                </p>
                <div className="footer-contact-info">
                  <span>
                    <a href="mailto:info@stackular.com" aria-label="mail">
                      {data?.elements?.email?.value.replace(
                        /(<([^>]+)>)/gi,
                        ""
                      )}
                    </a>
                  </span>
                  <span>
                    <a
                      href="tel:+14436097406"
                      className="telephone"
                      aria-label="Telephone"
                    >
                      {data?.elements?.telephone?.value.replace(
                        /(<([^>]+)>)/gi,
                        ""
                      )}
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-2 ">
              <div className="footer-links">
                <figure className="figure footer-right-img-area">
                  <img loading="lazy"
                    src={data?.elements?.footer_img?.value[0]?.url}
                    className="figure-img img-fluid rounded"
                    alt="Logo"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row footer_second">
            <div className="col-lg-3  d-flex logo">
              <div className="mt-2 footer-logo">
                <img loading="lazy" src={Logo_b} alt="logo" />
              </div>
            </div>
            <div className="col-lg-6  footer-links d-flex"></div>
            <div className="col-lg-3  footer-links">
              <div className="social-links d-flex">
                <a
                  href="https://twitter.com/stackular"
                  className="twitter"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Follow us on Twitter"
                >
                  <TwitterX />
                </a>
                <a
                  href="https://wa.me/message/7LAHPO3MWQKZL1"
                  className="whatsapp"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Follow us on Whatsapp"
                >
                  <Whatsapp />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100088815441246"
                  className="facebook"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Follow us on Facebook"
                >
                  <Facebook />
                </a>

                <a
                  href="https://www.linkedin.com/company/stackular/"
                  className="linkedin"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Follow us on Linkedin"
                >
                  <Linkedin />
                </a>

                <a
                  href="https://github.com/Stackular"
                  className="github"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Follow us on github"
                >
                  <Github />
                </a>
                <a
                  href="https://www.instagram.com/stackular/"
                  className="instagram"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <Instagram className="instagram-icon" />
                  <InstagramColoredIcon className="instagram-colored-icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row footer_third">
            <div className="d-flex justify-content-between align-items-center w-100 border-t">
              <div className="copyright">
                &copy; {new Date().getFullYear()}, All Rights Reserved
              </div>
              <div className="privacy-policy-link d-flex align-items-center gap-3">
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  Privacy Policy
                </a>
                {cookieConsent === COOKIE_CONSENT.ACCEPTED && (
                    <button
                    type="button"
                    onClick={openCookieSettings}
                    className="btn btn-link p-0 text-decoration-none"
                  >
                        Cookies: Accepted
                    </button>
                )}

                {cookieConsent === COOKIE_CONSENT.REJECTED && (
                    <button
                    type="button"
                    onClick={openCookieSettings}
                    className="btn btn-link p-0 text-decoration-none"
                  >
                        Cookies: Rejected
                    </button>
                )}

                {!cookieConsent && (
                    <button
                    type="button"
                    onClick={openCookieSettings}
                    className="btn btn-link p-0 text-decoration-none"
                  >
                        Cookie Settings
                    </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </footer>
      <button
        onClick={openCookieSettings}
        className="cookie-settings-btn"
        aria-label="Cookie Settings"
      >
        🍪
      </button>
      <a
        href="#scroll-to-top"
        className={`scroll-top ${
          isActive ? "active" : ""
        } d-flex align-items-center justify-content-center`}
        onClick={scrollToTop}
        aria-label="scroll To up button"
      >
        <ArrowUpShort size="1.7em" className="scroll-top-btn" />
      </a>
    </>
  );
};

export default Footer;
